import { useEffect, useState } from "react";
import { useLang } from "@/lib/i18n";
import { LogoMark } from "@/components/Logo";
import { X, Download, Share } from "lucide-react";

const KEY = "fscd_install_dismissed";

const TXT = {
  title: { en: "Install FSCD on your phone", hi: "FSCD अपने फ़ोन पर इंस्टॉल करें" },
  body: { en: "One-tap access from your home screen — works like an app.", hi: "होम स्क्रीन से एक टैप में खोलें — ऐप की तरह चलता है।" },
  install: { en: "Install", hi: "इंस्टॉल करें" },
  iosBody: { en: "Tap the Share button, then \"Add to Home Screen\".", hi: "Share बटन दबाएं, फिर \"Add to Home Screen\" चुनें।" },
};

export default function InstallBanner() {
  const { pick } = useLang();
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    const standalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (standalone || window.innerWidth >= 768) return;
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent);
    if (isIos) {
      setIos(true);
      setShow(true);
      return;
    }
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
      setShow(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setShow(false);
  };

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice.catch(() => {});
    }
    dismiss();
  };

  if (!show) return null;
  return (
    <div data-testid="install-banner" className="fixed bottom-16 sm:bottom-4 inset-x-3 z-[60] fade-in">
      <div className="max-w-md mx-auto bg-teal-900 text-white rounded-2xl shadow-2xl p-3.5 flex items-center gap-3">
        <LogoMark size={38} />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold leading-tight">{pick(TXT.title)}</p>
          <p className="text-[11px] text-teal-200 leading-snug mt-0.5 flex items-center gap-1">
            {ios && <Share size={11} className="shrink-0" />}
            {ios ? pick(TXT.iosBody) : pick(TXT.body)}
          </p>
        </div>
        {!ios && (
          <button data-testid="install-banner-btn" onClick={install}
            className="h-9 px-3.5 rounded-xl bg-white text-teal-900 text-xs font-bold inline-flex items-center gap-1 shrink-0">
            <Download size={13} /> {pick(TXT.install)}
          </button>
        )}
        <button data-testid="install-banner-dismiss" onClick={dismiss} className="text-teal-300 hover:text-white shrink-0 p-1">
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
